import { Grid, Typography } from '@mui/material';
import { UpdatePersonalInfo } from '../../../../common/context/types';
import { EditButton } from '../EditButton';

export const PersonalInfoView = ({ name, phoneNumber }: UpdatePersonalInfo) => {
  return (
    <Grid container padding={2}>
      <Grid item xs={12} md={6} display="flex">
        <Grid container pb={2}>
          <Grid item xs={12} md={5}>
            <Typography variant="h5">Name</Typography>
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography>{name}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6} display="flex">
        <Grid container>
          <Grid item xs={12} md={5} paddingRight={2}>
            <Typography variant="h5">Phone number</Typography>
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography>{phoneNumber}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} display="flex" justifyContent="flex-end" mx={1}>
        <EditButton name={'personalInfo'} />
      </Grid>
    </Grid>
  );
};
